import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Ubytovani: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Ubytování | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Stylové a klidné ubytování v přírodě Hostýnských vrchů."
        />
      </Helmet>

      {/* ================= NAVBAR – TOTÁLNÍ IZOLACE ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#531d08] overflow-x-hidden">

        {/* ================================================= */}
        {/* ================= MOBILE ======================= */}
        {/* ================================================= */}
        <section className="block lg:hidden px-5 pt-24 space-y-6">

          <h1 className="text-2xl font-bold text-center font-serif">
            Ubytování
          </h1>

          <p className="text-xs text-center font-serif -mt-2">
            Probuďte se do srdce valašské přírody
          </p>

          <img
            src="./img/hlavni-interier.jpg"
            alt="Pokoj"
            className="w-full rounded-md object-cover"
          />

          <p className="text-xs text-center pb-3 font-serif">
            Pokoj s <b>manželskou postelí</b> a výhledem do lesa
          </p>

          {/* IKONY */}
          <div className="flex justify-around mt-6">
            {[
              "./img/wifi-logo.PNG",
              "./img/tv-logo.PNG",
              "./img/parkovani-logo.PNG",
              "./img/snidane-logo.PNG",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                className="w-12 h-12 object-contain"
                alt=""
              />
            ))}
          </div>

          <p className="text-sm leading-relaxed text-left pt-4">
            K dispozici jsou nově zrekonstruované pokoje s vlastní koupelnou.
            Ideální pro rodiny, páry, firemní pobyty i klidný odpočinek.
          </p>

          {/* VĚTŠÍ CTA */}
          <div className="pt-6">
            <Link to="/rezervace-ubytovani">
              <button className="w-full bg-[#60260F] text-white px-6 py-4 rounded-lg text-base font-semibold">
                Rezervace
              </button>
            </Link>
          </div>

          {/* GALERIE */}
          <div className="space-y-3 pt-6">
            <img src="./img/ubytovani/ubytovani-1.jpg" className="rounded-md w-full" alt="Pokoj v ubytování Hospůdky pod Rablinů" />
            <img src="./img/ubytovani/ubytovani-3.jpg" className="rounded-md w-full" alt="Interiér pokoje v Hospůdce pod Rablinů" />
            <img src="./img/ubytovani/ubytovani-4.jpg" className="rounded-md w-full" alt="Detail ubytování v Hospůdce pod Rablinů" />
          </div>

          <Link to="/mobile-fotogalerie-ubytovani">
            <p className="text-center underline text-[#60260F] pb-10 pt-10">
              Více fotografií zde
            </p>
          </Link>

          <div className="bg-white rounded-2xl shadow-md border border-[#e8d6b8] p-5 mb-10">
            <div className="text-center border-b border-[#eadcc4] pb-4 mb-4">
              <p className="text-[11px] uppercase tracking-[0.22em] text-[#8c5a3c]">
                Ubytování
              </p>
              <h2 className="text-xl font-bold font-serif mt-2">
                Ceník ubytování
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { label: "1 noc", value: "850 Kč / osoba" },
                { label: "2 a více nocí", value: "750 Kč / osoba", highlight: true },
                { label: "Děti do 3 let", value: "Zdarma" },
              ].map((item) => (
                <div
                  key={item.label}
                  className={`rounded-xl px-4 py-4 flex items-center justify-between gap-4 ${
                    item.highlight
                      ? "bg-[#60260F] text-white shadow-sm"
                      : "bg-[#f8efe1] text-[#531d08]"
                  }`}
                >
                  <span className="font-semibold">{item.label}</span>
                  <span className="text-right font-bold">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

        </section>

        {/* ================================================= */}
        {/* ================= DESKTOP ====================== */}
        {/* ================================================= */}
        <section className="hidden lg:block">

          {/* BÍLÝ BLOK */}
          <div className="bg-white py-20 text-center">
            <h1 className="text-4xl font-bold font-serif">
              UBYTOVÁNÍ
            </h1>

            <p className="max-w-3xl mx-auto mt-6 leading-relaxed">
              Nově zrekonstruované pokoje s vlastní koupelnou,
              možností přistýlky a výhledem do lesa.
            </p>
          </div>

          {/* 3 FOTKY */}
          <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6 mt-16 px-10">
            {[
              "./img/fotka-interier-3.jpg",
              "./img/hlavni-interier.jpg",
              "./img/aktualni/hospudka-pod-rablinu.jpg",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                className="h-72 w-full object-cover rounded-xl shadow"
                alt="Fotografie ubytování Hospůdky pod Rablinů"
              />
            ))}
          </div>

          <p className="text-center max-w-4xl mx-auto mt-14 text-lg">
            Ať už plánujete rodinný pobyt, romantický víkend nebo firemní akci,
            u nás najdete klid, pohodlí a přírodu.
          </p>

          {/* CTA */}
          <div className="flex justify-center mt-10">
            <Link to="/rezervace-ubytovani">
              <button className="bg-[#60260F] hover:bg-[#965126] text-white px-12 py-4 rounded-xl text-lg font-semibold">
                Rezervace ubytování
              </button>
            </Link>
          </div>

          {/* DALŠÍ OBSAH */}
          <img
            src="./img/party.jpg"
            className="w-3/4 mx-auto mt-24 rounded-2xl object-cover max-h-[35vh]"
            alt="Zázemí a atmosféra areálu Hospůdky pod Rablinů"
          />

          <p className="text-center max-w-4xl mx-auto mt-14 text-lg">
          Součástí naší hospůdky je také zastřešené pódium pro letní akce, které vytváří ideální zázemí pro koncerty, živou hudbu, oslavy i tematické večery.
          </p>


          {/* CENÍK */}
          <div className="max-w-md md:max-w-none md:w-3/4 mx-auto mb-10 mt-24 px-4 md:px-0">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-serif text-[#60260F]">
                Ceník ubytování
              </h3>
              <div className="w-12 h-px bg-[#c9a878] mx-auto mt-4" />
            </div>

            <div className="bg-white rounded-2xl border border-[#e0cbaa] shadow-[0_10px_30px_-15px_rgba(96,38,15,0.35)] overflow-hidden">
              {[
                { label: "1 noc", value: "850 Kč / osoba" },
                { label: "2 a více nocí", value: "750 Kč / osoba", note: "výhodnější" },
                { label: "Děti do 3 let", value: "Zdarma" },
              ].map((item, i, arr) => (
                <div
                  key={item.label}
                  className={`flex items-baseline justify-between gap-4 px-6 py-5 ${
                    i < arr.length - 1 ? "border-b border-[#efe3cf]" : ""
                  } ${item.note ? "bg-[#fbf3e6]" : ""}`}
                >
                  <span className="text-[#3d2a1c]">
                    {item.label}
                    {item.note && (
                      <span className="ml-2 text-[11px] uppercase tracking-wider text-[#a07750]">
                        {item.note}
                      </span>
                    )}
                  </span>
                  <span className="font-semibold text-[#60260F] whitespace-nowrap">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

        
        </section>
        <Footer />
      </main>
    </>
  );
};

export default Ubytovani;
